import gql from 'graphql-tag'
import client from '@stores/apollo'
import { CompanyAssetFragment } from '@api/fragments'
import { ICompanyAsset } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  createCompanyAsset: { asset: ICompanyAsset }
  updateCompanyAsset: { asset: ICompanyAsset }
}

const createMutateHandler = handleFetchResult<IPayload, ICompanyAsset>({
  handler: (data) => data.createCompanyAsset.asset,
  name: 'Asset',
})

const updateMutateHandler = handleFetchResult<IPayload, ICompanyAsset>({
  handler: (data) => data.updateCompanyAsset.asset,
  name: 'Asset',
})

function create(content: string): Promise<ICompanyAsset> {
  return client.gql
    .mutate({ mutation: createMutation, variables: { input: { content } } })
    .then(createMutateHandler)
}

function update(id: string, content: string): Promise<ICompanyAsset> {
  return client.gql
    .mutate({ mutation: updateMutation, variables: { input: { content, id } } })
    .then(updateMutateHandler)
}

function remove(id: string) {
  return client.gql.mutate({
    mutation: removeMutation,
    variables: { input: { id } },
  })
}

const createMutation = gql`
  mutation createAssetMutation($input: CreateCompanyAssetInput!) {
    createCompanyAsset(input: $input) {
      asset {
        ...CompanyAssetFragment
      }
    }
  }
  ${CompanyAssetFragment}
`

const updateMutation = gql`
  mutation updateAssetMutation($input: UpdateCompanyAssetInput!) {
    updateCompanyAsset(input: $input) {
      asset {
        ...CompanyAssetFragment
      }
    }
  }
  ${CompanyAssetFragment}
`

const removeMutation = gql`
  mutation deleteCompanyAsset($input: DeleteCompanyAssetInput!) {
    deleteCompanyAsset(input: $input) {
      asset {
        id
      }
    }
  }
`

export default { create, update, remove }
